import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { MDBView } from "mdbreact";
import Status from "./status.jsx";
import {
  BROWSE,
  RESET,
  SetFILTERED,
  SetACTIVE_STATUS,
  InsertRealtimeOnboard,
} from "../../../../../../services/redux/slices/commerce/pos/services/taskGenerator.js";
import Search from "../../../../../../components/searchables/search.jsx";
import {
  getDepartment,
  socket,
} from "../../../../../../services/utilities/index.js";
import { useToasts } from "react-toast-notifications";

export default function Header() {
  const { token, activePlatform, auth } = useSelector(({ auth }) => auth),
    { collections } = useSelector(({ taskGenerator }) => taskGenerator),
    [status, setStatus] = useState("All"),
    { addToast } = useToasts(),
    dispatch = useDispatch();

  //Initial Browse and Fetch Data
  useEffect(() => {
    if (token && activePlatform?.branchId && auth._id) {
      const timezone = Intl.DateTimeFormat().resolvedOptions()?.timeZone;

      dispatch(
        BROWSE({
          key: {
            branchId: activePlatform?.branchId,
            department: activePlatform?.department,
            timezone,
          },
          token,
        })
      );
    }

    return () => {
      dispatch(RESET());
    };
  }, [token, dispatch, activePlatform, auth]);

  useEffect(() => {
    socket.on("received_onboard", (data) => {
      const { branchId } = activePlatform;
      if (data?.branchId === branchId) {
        const pn = collections.length + 1;
        dispatch(
          InsertRealtimeOnboard({
            ...data,
            pn,
            department: getDepartment(activePlatform?.department),
          })
        );
        addToast(`New patient onboarded. No. ${pn}`, {
          appearance: "success",
        });
      }
    });

    return () => {
      socket.off("received_onboard");
    };
  }, [activePlatform, dispatch, collections, addToast]);

  return (
    <MDBView
      cascade
      className="gradient-card-header custom-header blue-gradient narrower py-2 mx-4  d-flex justify-content-between align-items-center"
    >
      <div className="d-flex justify-items-center" style={{ width: "20rem" }}>
        <span className="white-text mx-3 text-nowrap mt-0">
          {collections.length}-Onboarded
        </span>
      </div>
      <div className="ml-n5">LABORATORY DEPARTMENT</div>

      <div className="d-flex align-items-center">
        <div className=" d-flex align-items-center mr-4">
          <span className="mr-1 ">Status:</span>
          <Status setStatus={setStatus} status={status} />
        </div>
        <Search
          collections={collections}
          haveAction={false}
          setFiltered={(results) => dispatch(SetFILTERED(results))}
          reset={() => {
            dispatch(SetFILTERED(collections));
            dispatch(SetACTIVE_STATUS("All"));
          }}
        />
      </div>
    </MDBView>
  );
}
